<section class="flex flex-col lg:flex-row">
  <div class="flex lg:grow">
    <article class="flex items-center justify-between gap-2">
      @for (segment of SEGMENTS; track segment) {
        <button
          [appClicks]="'users-list - ' + segment.label"
          (click)="selectedSegment.set(segment)"
          class="w-full cursor-pointer rounded-md px-6 py-1 text-center text-sm font-bold whitespace-nowrap transition-all duration-200 hover:scale-105 hover:drop-shadow-[0px_2px_4px_#000000aa]"
          [class.segment-active]="selectedSegment().key === segment.key"
          [class.text-neutral-400]="selectedSegment().key !== segment.key"
          [class.italic]="selectedSegment().key !== segment.key">
          {{ segment.label }}
        </button>
      }
    </article>
  </div>

  <div class="flex items-center justify-between">
    <div class="flex-1">
      <search
        [(searchTerm)]="searchTerm"
        placeholder="Buscar..."></search>
    </div>

    <div class="flex flex-1 justify-end">
      <selector
        [labelClick]="'users-list filter ' + selectedFilter()"
        [options]="FILTER_TYPES"
        [(selectedOption)]="selectedFilter">
        <div icon>
          <icon name="filter-icon"></icon>
        </div>
      </selector>
    </div>
  </div>
</section>

<section
  class="grid grid-cols-[repeat(auto-fill,minmax(180px,1fr))] gap-4 lg:grid-cols-[repeat(auto-fill,minmax(300px,1fr))]">
  @for (user of filteredUsers(); track user.uid) {
    <pilots-item [user]="user"></pilots-item>
  } @empty {
    <not-found class="col-span-full"></not-found>
  }
</section>
